import React from 'react';
import '../styles/Technology.css';

const Technology = () => {
    const techs = [
        {
            title: 'IoT',
            description: '원활한 데이터 교환을 위한 사물인터넷 연결성.',
            icon: 'fas fa-network-wired'
        },
        {
            title: 'Physical AI',
            description: '센서와 액추에이터를 통해 물리 세계와 상호작용하는 AI.',
            icon: 'fas fa-robot'
        },
        {
            title: 'On-Device AI',
            description: '엣지 디바이스에서 실시간 AI 처리.',
            icon: 'fas fa-microchip'
        },
        {
            title: 'Data Science',
            description: '센서 데이터에서 인사이트를 도출하는 고급 분석.',
            icon: 'fas fa-chart-line'
        }
    ];

    return (
        <div className="section technology-section">
            <div className="container">
                <h2 className="section-title">핵심 기술</h2>
                <div className="tech-grid">
                    {techs.map((tech, index) => (
                        <div className="tech-card" key={index}>
                            <div className="tech-icon">
                                <i className={tech.icon}></i>
                            </div>
                            <h3 className="tech-title">{tech.title}</h3>
                            <p className="tech-desc">{tech.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Technology;
